import {
  DoboxRuleApplyTarget,
  InboxEntry,
  UserCommunication,
} from '@this+that/models';

import { CHAT_PLATFORMS } from './constants';

export const isChatCommunication = (
  comm: Partial<UserCommunication>,
): boolean => !!comm.platform && CHAT_PLATFORMS.has(comm.platform);

export const resolveApplyTarget = (
  inboxEntry: InboxEntry,
): DoboxRuleApplyTarget | undefined => {
  const communications = inboxEntry.communications || [];

  if (communications.length === 0) {
    return undefined;
  }

  const chatCount = communications.filter(isChatCommunication).length;
  const emailCount = communications.length - chatCount;

  if (emailCount === 0) {
    return DoboxRuleApplyTarget.REAL_TIME_PLATFORMS;
  }

  if (chatCount === 0) {
    return DoboxRuleApplyTarget.EMAIL;
  }

  return undefined;
};
